import { gsap } from 'gsap';

function textSetup(el) {
  gsap.set(el, { autoAlpha: 0, y: 50 });
}

function textEnter(el) {
  gsap.to(el, { autoAlpha: 1, y: 0, ease: 'power2.out', duration: 1 });

}

export { textSetup, textEnter };